/**
 * Multi service booking will be considered available if its bookings are available as returned from ListMultiServiceAvailabilityTimeSlots API.
 * Currently, `SEPERATE_BOOKINGS` and `PARALLEL_BOOKINGS` are not supported.
 * Multi service booking will be considered available if each of its bookings is available separately.
 * For `SEQUENTIAL_BOOKINGS`, see [List Multi Service Availability Time Slots] (url) documentation // todo: complete url
 */
export var MultiServiceBookingType;
(function (MultiServiceBookingType) {
    MultiServiceBookingType["SEQUENTIAL_BOOKINGS"] = "SEQUENTIAL_BOOKINGS";
    MultiServiceBookingType["SEPARATE_BOOKINGS"] = "SEPARATE_BOOKINGS";
    MultiServiceBookingType["PARALLEL_BOOKINGS"] = "PARALLEL_BOOKINGS";
})(MultiServiceBookingType || (MultiServiceBookingType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var ValueType;
(function (ValueType) {
    /** Short text. This is the default value type. */
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    /** Long text. */
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    /** A text that represents the check box value. If selected the value is `true`, otherwise `false`. */
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType || (ValueType = {}));
/** Booking status. */
export var BookingBookingStatus;
(function (BookingBookingStatus) {
    /** The booking was created. */
    BookingBookingStatus["CREATED"] = "CREATED";
    /** The booking was confirmed. */
    BookingBookingStatus["CONFIRMED"] = "CONFIRMED";
    /** The booking was canceled. */
    BookingBookingStatus["CANCELED"] = "CANCELED";
    /** The booking is waiting to be confirmed or declined by the business owner. */
    BookingBookingStatus["PENDING"] = "PENDING";
    /** The booking was declined by the business owner. */
    BookingBookingStatus["DECLINED"] = "DECLINED";
    /** The booking is on a wait list. */
    BookingBookingStatus["WAITING_LIST"] = "WAITING_LIST";
})(BookingBookingStatus || (BookingBookingStatus = {}));
/**
 * Payment status.
 * Automatically updated when using eCom checkout APIs.
 */
export var BookingPaymentStatus;
(function (BookingPaymentStatus) {
    /** Undefined payment status. */
    BookingPaymentStatus["UNDEFINED"] = "UNDEFINED";
    /** The booking is not paid for. */
    BookingPaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** The booking is fully paid. */
    BookingPaymentStatus["PAID"] = "PAID";
    /** The booking is partially paid. */
    BookingPaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    /** The booking is refunded. */
    BookingPaymentStatus["REFUNDED"] = "REFUNDED";
    /** The booking is free of charge. */
    BookingPaymentStatus["EXEMPT"] = "EXEMPT";
})(BookingPaymentStatus || (BookingPaymentStatus = {}));
/**
 * The selected payment option.
 * One of the payment options offered by the service.
 * This field is be set when the user selects an option during booking.
 * If left undefined, the payment option is resolved by the service configuration on checkout.
 */
export var V2SelectedPaymentOption;
(function (V2SelectedPaymentOption) {
    /** Undefined payment option. */
    V2SelectedPaymentOption["UNDEFINED"] = "UNDEFINED";
    /** Offline payment. */
    V2SelectedPaymentOption["OFFLINE"] = "OFFLINE";
    /** Online payment. */
    V2SelectedPaymentOption["ONLINE"] = "ONLINE";
    /** Payment using a membership. */
    V2SelectedPaymentOption["MEMBERSHIP"] = "MEMBERSHIP";
    /** Payment can only be done using a membership and must be manually redeemed in the dashboard by the site owner. */
    V2SelectedPaymentOption["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(V2SelectedPaymentOption || (V2SelectedPaymentOption = {}));
export var BookingSourcePlatform;
(function (BookingSourcePlatform) {
    BookingSourcePlatform["UNDEFINED_PLATFORM"] = "UNDEFINED_PLATFORM";
    BookingSourcePlatform["WEB"] = "WEB";
    BookingSourcePlatform["MOBILE_APP"] = "MOBILE_APP";
})(BookingSourcePlatform || (BookingSourcePlatform = {}));
export var BookingSourceActor;
(function (BookingSourceActor) {
    BookingSourceActor["UNDEFINED_ACTOR"] = "UNDEFINED_ACTOR";
    BookingSourceActor["BUSINESS"] = "BUSINESS";
    BookingSourceActor["CUSTOMER"] = "CUSTOMER";
})(BookingSourceActor || (BookingSourceActor = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var LocationLocationType;
(function (LocationLocationType) {
    /** Undefined location type. */
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    /** The business address as set in the site’s general settings. */
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    /** The address as set when creating the service. */
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    /** The address set for the individual session. */
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType || (LocationLocationType = {}));
export var IdentificationDataIdentityType;
(function (IdentificationDataIdentityType) {
    IdentificationDataIdentityType["UNKNOWN"] = "UNKNOWN";
    IdentificationDataIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentificationDataIdentityType["MEMBER"] = "MEMBER";
    IdentificationDataIdentityType["WIX_USER"] = "WIX_USER";
    IdentificationDataIdentityType["APP"] = "APP";
})(IdentificationDataIdentityType || (IdentificationDataIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map